const i18nTexts = {
    'pt-BR': {
        About_Header: 'Sobre',
        Project_Header: 'Projetos',
        Contact_Header: 'Contato',

        TextProfession_Intro: 'Unity Programmer',
        TextPresentation_Intro: 'Olá, me chamo Giovana Melo',
        TextProfile_Intro: 'Sou desenvolvedora Unity a mais de 5 anos, com experiência em jogos para PC, Mobile, Web, XR e AR. Me interesso principalmente por desenvolver ferramentas e sistemas, sempre buscando atingir códigos limpos e escaláveis.',
        TextButtonCurriculum_Intro: 'Curriculo',

        Section_Project: 'Projetos',
        Description_Solis_Project: 'Solis é um emocionante jogo cooperativo de plataforma e quebra-cabeças para dois jogadores.',
        Description_Broccoli_Project: "Broccoli's Ascension é uma aventura de um brocolis em período de germinação.",
        Description_BetweenDeath_Project: 'Explore um universo onde a linha entre a vida e a morte se torna tênue e descubra um mundo envolto em mistério e trevas.',
        Button_View_Project: 'Ver Mais',

        Section_About: 'Sobre Mim',
        TextProfile_01_About: 'Sou formada em Jogos Digitais pela PUC Minas e desde pequena sou apaixonada pela criação de jogos, toda a psicologia envolvida e inteligência artificial. Já atuei em diversos tipos jogos e projetos, desde a prototipagem até a finalização, com maior experiência em jogos sérios e simulações. Meu foco é na programação de sistemas de gameplay e ferramentas, com o intuito de facilitar tarefas mais repetitivas e trabalhosas.',
        TextProfile_extra_About: 'Meu diferencial é gostar muito de desafios novos, de estudar e estar sempre buscando conhecimento para me atualizar e melhorar minhas habilidades.',
        Achievement_01_About: 'Bacharelado em Jogos Digitais - PUC Minas',


        Section_Experience: 'Experiência',

        // -- Experiencia 01 --
        Title_01_Experience: 'Desenvolvedora Unity',
        Company_01_Experience: 'RD3 Digital',
        Type_01_Experience: 'Tempo integral',
        Dates_01_Experience: 'maio de 2024 - o momento',
        Location_01_Experience: 'Remota',

        // -- Experiencia 02 --
        Title_02_Experience: 'Desenvolvedora de Jogos',
        Company_02_Experience: 'Buff Buff Studios',
        Type_02_Experience: 'Freelance',
        Dates_02_Experience: 'fev de 2023 - dez de 2024',
        Location_02_Experience: 'Belo Horizonte, Minas Gerais - Brasil',

        // -- Experiencia 03 --
        Title_03_Experience: 'Desenvolvedora Unity',
        Company_03_Experience: 'Aioros Studios',
        Type_03_Experience: 'Tempo integral',
        Dates_03_Experience: 'set de 2022 - mai de 2024',
        Location_03_Experience: 'Belo Horizonte, Minas Gerais - Brasil',

        // -- Experiencia 04 --
        Title_04_Experience: 'Desenvolvedora de Jogos',
        Company_04_Experience: 'Minas Educa',
        Type_04_Experience: 'Estágio',
        Dates_04_Experience: 'mar de 2021 - set de 2022',
        Location_04_Experience: 'Belo Horizonte, Minas Gerais - Brasil',
       

        TitlePage_Contact: 'Contato',
        TitleForm_Contact: 'Entre em Contato',
        NameForm_Contact: 'Nome',
        SubjectForm_Contact: 'Assunto',
        EmailForm_Contact: 'Email',
        MessageForm_Contact: 'Mensagem',
        ButtonSendForm_Contact: 'Enviar',
        ResponseSendForm_Contact: 'Mensagem Enviada',
        NameLogoContact: 'Giomelo',
        TelephoneLogoContact: '+55 (31)98211-9063',
        CopyEmailContact: 'Copiar Email',

        TitlePage_Footer: 'GIOMELO',
        SubtitlePage_Footer: 'Unity Programmer',
        SocialPage_Footer: 'SOCIAL',
        Created_Footer: 'Desenvolvido por',

        TitlePage_ProjectsProfessional: 'Profissional',
        TitlePage_ProjectsPersonal: 'Pessoal',
        Game_Projects: 'Projetos',
        GameText_Projects: 'Clique no projeto para saber mais',
        // Projetos profissionais
        Description_TransitandoLegal_Projects: 'Jogo de Tabuleiro Educativo: Uma experiência interativa que combina sistemas de randomização e balanceamento dinâmico a uma série de minijogos integrados, focados no engajamento e aprendizado.',
        Description_TimOrgulho_Projects: 'Jogo inspirado na mecânica de Flappy Bird, desenvolvido com modos single player e multiplayer para campanha promocional.',
        Description_Bernoulli_Projects: 'Jogos educativos 2D desenvolvidos para o Grupo Bernoulli, focados no aprendizado lúdico e interatividade.',
        Description_Belgo_Projects: 'Runner Belgo – Jogo de corrida infinita desenvolvido para a marca',
        Description_MicheleAR_Projects: 'Jogo de memória em Realidade Aumentada utilizando Image Target.',
        Description_AtlasCNT_Projects: 'Visualizador de mapas em Realidade Aumentada, integrando tecnologias de Image Target e detecção de Ground Plane para uma experiência imersiva em atlas.',
        Description_Scafom_Projects: 'O Scafom Rux Dynamic é um simulador de montagem de andaimes em VR onde liderei toda a programação e arquitetura do sistema. Desenvolvi uma mecânica de encaixe precisa e intuitiva, estruturando a lógica via diagramas de classes para garantir escalabilidade. Um diferencial técnico foi o sistema de validação de segurança, que alerta sobre estruturas fora das normas. Para agilizar os testes, criei uma ferramenta personalizada no Unity Editor que permitia validar múltiplos cenários de montagem de forma rápida.',
        Description_Nr35_Projects: 'Simulador de resgate em altura em realidade virtual.',
    },
    'en-US': {
        About_Header: 'About',
        Project_Header: 'Projects',
        Contact_Header: 'Contact',

        TextProfession_Intro: 'Unity Programmer',
        TextPresentation_Intro: "Hi, I'm Giovana Melo",
        TextProfile_Intro: 'I have been a Unity developer for over 5 years, with experience in PC, Mobile, Web, XR, and AR games. I am mainly interested in developing tools and systems, always striving for clean and scalable code.',
        TextButtonCurriculum_Intro: 'Resume',

        Section_Project: 'Projects',
        Description_Solis_Project: 'Solis is an exciting cooperative puzzle-platformer for two players.',
        Description_Broccoli_Project: "Broccoli's Ascension is an adventure following a broccoli during its germination period.",
        Description_BetweenDeath_Project: 'Explore a universe where the line between life and death thins, and discover a world shrouded in mystery and darkness.',
        Button_View_Project: 'View More',

        Section_About: 'About Me',
        TextProfile_01_About: 'I hold a degree in Digital Games from PUC Minas. Since I was young, I have been passionate about game creation, the psychology behind it, and artificial intelligence. I have worked on various types of games and projects, from prototyping to final release, with extensive experience in serious games and simulations. My focus is on programming gameplay systems and tools to streamline repetitive and labor-intensive tasks.',
        TextProfile_extra_About: 'My key strength is my love for new challenges and my constant drive to study and stay up to date to improve my skills.',
        Achievement_01_About: 'Bachelor of Digital Games - PUC Minas',


        Section_Experience: 'Experience',

        // -- Experience 01 --
        Title_01_Experience: 'Unity Developer',
        Company_01_Experience: 'RD3 Digital',
        Type_01_Experience: 'Full-time',
        Dates_01_Experience: 'May 2024 - Present',
        Location_01_Experience: 'Remote',

        // -- Experience 02 --
        Title_02_Experience: 'Game Developer',
        Company_02_Experience: 'Buff Buff Studios',
        Type_02_Experience: 'Freelance',
        Dates_02_Experience: 'Feb 2023 - Dec 2024',
        Location_02_Experience: 'Belo Horizonte, Minas Gerais - Brazil',

        // -- Experience 03 --
        Title_03_Experience: 'Unity Developer',
        Company_03_Experience: 'Aioros Studios',
        Type_03_Experience: 'Full-time',
        Dates_03_Experience: 'Sep 2022 - May 2024',
        Location_03_Experience: 'Belo Horizonte, Minas Gerais - Brazil',

        // -- Experience 04 --
        Title_04_Experience: 'Game Developer',
        Company_04_Experience: 'Minas Educa',
        Type_04_Experience: 'Internship',
        Dates_04_Experience: 'Mar 2021 - Sep 2022',
        Location_04_Experience: 'Belo Horizonte, Minas Gerais - Brazil',
        

        TitlePage_Contact: 'Contact',
        TitleForm_Contact: 'Get in Touch',
        NameForm_Contact: 'Name',
        SubjectForm_Contact: 'Subject',
        EmailForm_Contact: 'Email',
        MessageForm_Contact: 'Message',
        ButtonSendForm_Contact: 'Send',
        ResponseSendForm_Contact: 'Message Sent',
        NameLogoContact: 'Giomelo',
        TelephoneLogoContact: '+55 (31) 98211-9063',
        CopyEmailContact: 'Copy Email',

        TitlePage_Footer: 'GIOMELO',
        SubtitlePage_Footer: 'Unity Programmer',
        SocialPage_Footer: 'SOCIAL',
        Created_Footer: 'Developed by',

        TitlePage_ProjectsProfessional: 'Professional',
        TitlePage_ProjectsPersonal: 'Personal',
        Game_Projects: 'Projects',
        GameText_Projects: 'Click on a project to learn more',

        // Professional Projects
        Description_TransitandoLegal_Projects: 'Educational Board Game: An interactive experience combining randomization and dynamic balancing systems with a series of integrated minigames focused on engagement and learning.',
        Description_TimOrgulho_Projects: 'Game inspired by Flappy Bird mechanics, developed with single-player and multiplayer modes for a promotional campaign.',
        Description_Bernoulli_Projects: '2D educational games developed for the Bernoulli Group, focused on playful learning and interactivity.',
        Description_Belgo_Projects: 'Belgo Runner – An endless runner game developed for the brand.',
        Description_MicheleAR_Projects: 'Augmented Reality memory game using Image Targets.',
        Description_AtlasCNT_Projects: 'Augmented Reality map viewer, integrating Image Target and Ground Plane detection technologies for an immersive atlas experience.',
        Description_Scafom_Projects: 'Scafom Rux Dynamic is a VR scaffolding assembly simulator where I led the entire programming and system architecture. I developed precise and intuitive snapping mechanics and structured the logic via class diagrams to ensure scalability. A technical highlight was the safety validation system, which alerts users about structures that do not meet regulations. To speed up testing, I created a custom tool in the Unity Editor to quickly validate multiple assembly scenarios.',
        Description_Nr35_Projects: 'Virtual Reality simulator for high-altitude rescue training.'
    },
};
  
export default i18nTexts;